// Growth uses v2 exclusively. Missing configuration leaves reports unsent instead of sending them elsewhere.
const V2_API = process.env.NEXT_PUBLIC_AI_APP_API

/** The visit endpoint, or null when tracking cannot be configured in this build. */
export const visitsUrl = () => (V2_API ? `${V2_API}/v2/visits` : null)

/**
 * A kept report or permanent input refusal needs no retry. Limits and temporary service failures are retried.
 */
export const reportDone = (response) =>
  response.ok || [400, 413, 422].includes(response.status)

/** Tie the current visitor to the authenticated account. */
export const linkRequest = (token, body) =>
  V2_API
    ? {
        url: `${V2_API}/v2/me/visitor`,
        init: {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(body),
        },
      }
    : null

// The attribution report's existing names, adapted to the v2 contract.
const CLICK_FIELDS = {
  aiffiliateUid: 'affiliate_id',
  aiffiliateTracker: 'tracker',
  clickRef: 'click_ref',
  clickedAt: 'clicked_at',
  landing: 'landing',
  referrerHost: 'referrer_host',
  sub1: 'sub1',
  sub2: 'sub2',
  sub3: 'sub3',
  sub4: 'sub4',
  sub5: 'sub5',
}

/** A click uses text/plain JSON so closing-page reports need no CORS preflight. */
export function clickRequest(body) {
  if (!V2_API) return null
  const sent = {}
  for (const [key, value] of Object.entries(body))
    if (Object.hasOwn(CLICK_FIELDS, key)) sent[CLICK_FIELDS[key]] = value
  return {
    url: `${V2_API}/v2/affiliate-clicks`,
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify(sent),
  }
}

/** A best-effort checkout-offer event; never part of charging the account. */
export const offerEventUrl = () =>
  V2_API ? `${V2_API}/v2/me/offer-events` : null
